// extracted by mini-css-extract-plugin
export default {"pictureBox":"Prayer_pictureBox__hGuJG","picture":"Prayer_picture__TDPiy","hide":"Prayer_hide__OSI3h"};